import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable({
  providedIn: 'root'
})
export class ProfileAppService extends RestfulService<Models.ProfileApp> {

  constructor(private restService: RestService) {
    super(Models.ProfileApp);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('profile-apps');
  }
}
